







































import ActionButton from '@/components/ActionButton.vue'
import ClientsCreateDialog from '@/components/Agency/Clients/ClientsCreateDialog.vue'
import { getClients } from '@/api/Agency/agency.api'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { Client } from '@/api/Agency/agency.interface'
import ClientsFilter from '@/components/Agency/Clients/ClientsFilter.vue'
import DeleteClient from '~/components/Agency/Clients/DeleteClient.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler<Client>().extend({
  components: {
    appClientsFilter: ClientsFilter,
    appActionButton: ActionButton,
    appClientsCreateDialog: ClientsCreateDialog,
    DeleteClient,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'identity',
        },
        {
          text: this.$t('reference'),
          value: 'reference_name',
        },
        {
          text: this.$t('receivers'),
          value: 'receivers',
        },
        {
          text: this.$t('name'),
          value: 'first_name',
        },
        {
          text: this.$t('lastname'),
          value: 'last_name',
        },
        {
          text: this.$t('address'),
          value: 'full_address',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
      getClients,
    }
  },
})
